
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Badge } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Badge`}</h1>
<p>{`Used to display number of items in a minimal form, usually for notifications. You should never have more than 1 adjacent badge components.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Badge } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Badge value={30} />`} component={Badge} mdxType="Playground">
  <Badge value={30} mdxType="Badge" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;